import RavenjsError from 'ravenjs/lib/Error';

/**
 * oAuth Error class, when oAuth information is missing
 *
 * @class
 * @extends RavenjsError
 */
class oAuthError extends RavenjsError {
    constructor(message = 'oAuth information missing.') {
        super(message);
    }
}

export default oAuthError;
